var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickonboading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.951,
    height: 42.983,
    viewBox: "0 0 50.951 42.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_18_1",
    "data-name": "Component 18 \\u2013 1",
    transform: "translate(1.366 1.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570",
    transform: "translate(-817.244 -758.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M845.334,785.229l7.168,4.463a1.98,1.98,0,0,0,2.728-.632l.026-.044h0a1.981,1.981,0,0,0-.655-2.683l-12.746-7.993a1.983,1.983,0,0,0-2.629.478l-2.736,3.592a1.982,1.982,0,0,1-2.777.375l-.067-.053-.012-.009a1.98,1.98,0,0,1-.332-2.689l4.109-5.635a1.979,1.979,0,0,1,1.578-.814l13.72-.166",
    transform: "translate(-0.306 -0.093)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M843.86,789.358l5.558,3.311a2.036,2.036,0,0,0,2.788-.714c.016-.026.029-.051.043-.076h0a2.035,2.035,0,0,0-.719-2.689l-5.981-3.726",
    transform: "translate(-0.52 -0.329)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M842.619,793.626l3.7,2.079a2.045,2.045,0,0,0,2.785-.774l.022-.039h0a2.044,2.044,0,0,0-.747-2.716l-4.549-2.74",
    transform: "translate(-0.487 -0.406)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M841.122,797.613l1.358.784a2.1,2.1,0,0,0,2.861-.772c.017-.028.032-.057.047-.086h0a2.1,2.1,0,0,0-.792-2.758l-1.982-1.075",
    transform: "translate(-0.467 -0.484)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2634",
    "data-name": "Rectangle 2634",
    width: 7.782,
    height: 3.958,
    rx: 1.979,
    transform: "translate(828.147 793.055) rotate(-57.736)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2635",
    "data-name": "Rectangle 2635",
    width: 6.873,
    height: 3.958,
    rx: 1.979,
    transform: "matrix(0.534, -0.846, 0.846, 0.534, 831.625, 794.99)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2636",
    "data-name": "Rectangle 2636",
    width: 5.638,
    height: 3.958,
    rx: 1.979,
    transform: "translate(835.42 796.559) rotate(-57.736)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2637",
    "data-name": "Rectangle 2637",
    width: 4.984,
    height: 3.958,
    rx: 1.979,
    transform: "translate(825.1 790.386) rotate(-57.736)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 2.378,
    x2: 3.259,
    transform: "translate(855.228 784.786)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 5.358,
    y2: 3.205,
    transform: "translate(830.122 773.326)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 3.599,
    y2: 2.392,
    transform: "translate(823.667 785.136)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2638",
    "data-name": "Rectangle 2638",
    width: 6.807,
    height: 14.932,
    rx: 0.506,
    transform: "translate(852.101 772.052) rotate(-30)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2639",
    "data-name": "Rectangle 2639",
    width: 14.932,
    height: 6.807,
    rx: 0.506,
    transform: "translate(817.244 782.144) rotate(-60)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_543-2",
    "data-name": "Path 543",
    d: "M-1300.951,254.472l2.787,5.288",
    transform: "translate(1223.854 -537.973) rotate(-13)",
    fill: "none",
    stroke: "#b4cd7c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544-2",
    "data-name": "Path 544",
    d: "M-1300.951,254.472l2.787,5.288",
    transform: "translate(1303.189 341.581) rotate(26)",
    fill: "none",
    stroke: "#b4cd7c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545-2",
    "data-name": "Path 545",
    d: "M-1298.164,254.472l-2.787,5.288",
    transform: "translate(1352.639 69.803) rotate(14)",
    fill: "none",
    stroke: "#b4cd7c",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickonboading);
export default __webpack_public_path__ + "static/media/quickonboading.a693a916b23d300f6041a59b24ba3b4e.svg";
export { ForwardRef as ReactComponent };